module.exports = __webpack_public_path__ + "img/automatization-dude.cf977b61.svg";